import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

const BASE = `${config.apis.api.url}/ai/artwork-autocomplete`;

const ArtworkAutocompleteService = {
  getEligibility({ artistId, galleryArtistId }) {
    const params = new URLSearchParams();
    if (artistId) params.set('artist_id', artistId);
    if (galleryArtistId) params.set('gallery_artist_id', galleryArtistId);
    return fetchWrapper.get(`${BASE}/eligibility?${params.toString()}`, { injectToken: true });
  },

  generate(payload) {
    return fetchWrapper.post(BASE, { injectToken: true, body: payload });
  },
};

export default ArtworkAutocompleteService;
